/**
 * posterarte-favoritos.js — los favoritos viajan con la cuenta.
 *
 * POR QUÉ EXISTE (2026-10-28). Una clienta guardó láminas en favoritos desde
 * Opera y, al entrar con su cuenta desde Gmail, no estaban. Los favoritos se
 * guardaban solo en el localStorage del navegador ("pa-wishlist"), que es de
 * cada navegador y no sabe nada de la cuenta.
 *
 * QUÉ HACE. Sin sesión, nada: los favoritos siguen en el navegador igual que
 * antes. Con sesión, el snippet pa-favoritos-cuenta pinta window.paFavCuenta
 * (id del cliente, token firmado por Liquid y la URL del Worker
 * delanima-favoritos), y este fichero:
 *   1. al cargar, lee los favoritos de la cuenta y los junta con los del
 *      navegador según la regla de abajo;
 *   2. cada vez que el corazón cambia la lista, la sube a la cuenta.
 *
 * LA REGLA DE FUSIÓN. "pa-wishlist-cuenta" recuerda con qué cuenta se
 * sincronizó este navegador por última vez.
 *   · vacío (nunca, o se editó sin sesión) → se SUMAN los dos lados: así no se
 *     pierde lo que se guardó antes de entrar;
 *   · la misma cuenta → manda la cuenta, para que una lámina quitada en otro
 *     dispositivo no resucite desde este;
 *   · otra cuenta → manda la cuenta: no se mezclan los favoritos de dos
 *     personas que comparten ordenador.
 *   Si la última subida falló ("pa-wishlist-pendiente"), manda el navegador.
 *
 * Avisa con el evento 'pa:favoritos' en document cuando la lista del
 * navegador cambia por la sincronización; posterarte.collection.js y
 * posterarte-wishlist-page.js lo escuchan para repintar.
 *
 * Si el Worker no responde, no se rompe nada: queda el comportamiento de
 * siempre y la subida se reintenta en la siguiente carga.
 */
(function () {
  'use strict';

  var CLAVE = 'pa-wishlist';
  var MARCA = 'pa-wishlist-cuenta';
  var PENDIENTE = 'pa-wishlist-pendiente';

  function leer(k) { try { return localStorage.getItem(k); } catch (_e) { return null; } }
  function escribir(k, v) { try { localStorage.setItem(k, v); } catch (_e) {} }
  function borrar(k) { try { localStorage.removeItem(k); } catch (_e) {} }

  /* Mismo formato que posterarte.collection.js: [{id, handle}], y tolera el
     formato antiguo de ids sueltos. */
  function local() {
    try {
      var arr = JSON.parse(leer(CLAVE) || '[]');
      if (!Array.isArray(arr)) return [];
      return arr.map(function (it) {
        if (typeof it === 'string') return { id: it, handle: '' };
        return it && it.id != null ? { id: String(it.id), handle: it.handle || '' } : null;
      }).filter(Boolean);
    } catch (_e) { return []; }
  }

  function huella(items) {
    return items.map(function (it) { return it.id; }).sort().join(',');
  }

  function unir(a, b) {
    var vistos = {};
    var out = [];
    a.concat(b).forEach(function (it) {
      if (!it || vistos[it.id]) return;
      /* Si un lado trae el handle y el otro no, se queda el que lo trae. */
      vistos[it.id] = true;
      var otro = b.concat(a).filter(function (x) { return x.id === it.id && x.handle; })[0];
      out.push({ id: it.id, handle: it.handle || (otro ? otro.handle : '') });
    });
    return out;
  }

  function contador(n) {
    document.querySelectorAll('.pa-wishlist-count').forEach(function (b) {
      b.textContent = n > 0 ? String(n) : '0';
      b.style.display = n > 0 ? '' : 'none';
    });
  }

  var cuenta = window.paFavCuenta;
  var activa = !!(cuenta && cuenta.cid && cuenta.t && cuenta.url);

  function llamar(cuerpo) {
    cuerpo.t = cuenta.t;
    /* text/plain: petición simple, sin OPTIONS previo. */
    return fetch(cuenta.url, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(cuerpo),
      credentials: 'omit',
      keepalive: true
    }).then(function (r) {
      if (!r.ok) throw new Error('favoritos ' + r.status);
      return r.json();
    });
  }

  var temporizador = null;
  function subir() {
    if (!activa) return Promise.resolve();
    escribir(PENDIENTE, '1');
    return llamar({ op: 'guardar', items: local() }).then(function () {
      borrar(PENDIENTE);
      escribir(MARCA, String(cuenta.cid));
    }).catch(function () { /* queda pendiente para la próxima carga */ });
  }

  /* Lo llaman los dos scripts del corazón justo después de guardar. */
  function cambio() {
    if (!activa) {
      /* Editado sin sesión: la próxima vez que entre, se suma a su cuenta. */
      borrar(MARCA);
      return;
    }
    clearTimeout(temporizador);
    temporizador = setTimeout(subir, 400);
  }

  function sincronizar() {
    if (!activa) return;
    var cid = String(cuenta.cid);
    var marca = leer(MARCA) || '';
    var pendiente = leer(PENDIENTE) === '1';
    var navegador = local();

    llamar({ op: 'leer' }).then(function (res) {
      var remota = (res && Array.isArray(res.items)) ? res.items : [];
      var final;
      if (pendiente && marca === cid) final = navegador;
      else if (marca === '') final = unir(remota, navegador);
      else final = remota;

      var cambiaNavegador = huella(final) !== huella(navegador);
      var cambiaCuenta = huella(final) !== huella(remota);

      escribir(CLAVE, JSON.stringify(final));
      escribir(MARCA, cid);
      if (cambiaCuenta) subir(); else borrar(PENDIENTE);

      if (cambiaNavegador) {
        contador(final.length);
        try { document.dispatchEvent(new CustomEvent('pa:favoritos')); } catch (_e) {}
      }
    }).catch(function () { /* sin red o Worker caído: se queda lo del navegador */ });
  }

  window.paFavoritos = { cambio: cambio, sincronizar: sincronizar, activa: activa };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sincronizar);
  } else {
    sincronizar();
  }
})();
